module.exports = __webpack_public_path__ + "img/lv.0b4e6e1a.svg";